<template>
  <div>
    <h4>Rechnungsdaten</h4>
    <b-card>
        <InvoiceForm />
    </b-card>
  </div>
</template>
<script>
    import InvoiceForm from "@/components/InvoiceForm";
    export default {
        components: {
            InvoiceForm
        }
    }
</script>
